const Palette = {
  main: {
    lightYellow: '#F5F3BB',
    lightBlue: '#90DDF0',
    darkBackground: '#080708',
    darkAccent: '#211C21',
    darkAccentLight: '#D8E4FF',
    flashyPink: '#FF5964'
  }
}

export default Palette
